import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'

export const Container = styled.nav`
  ${({ theme }) => theme.textStyles.m375_body}
  // @REMOVE if part of a bigger component
  width: 100%;
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  color: ${({ theme }) => theme.colors.black};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`
export const List = styled.ol`
  list-style: none;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.small};
  & li {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spaces.small};
  }
  & li:first-child {
    display: flex;
  }

  span {
    text-decoration: none;
  }
`
export const _Link = styled(Link)`
  color: inherit;
  text-decoration: underline;
  &[aria-current] {
    text-decoration: none;
    cursor: default;
  }
  &:is(a):hover,
  &:is(a):active,
  &:is(a):focus {
    text-decoration: none;
  }
`
export const Separator = styled.span``
